import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withKeys as _withKeys, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4a3a19f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tab-items-list"
}
const _hoisted_2 = {
  key: 0,
  class: "tab-items-list__create"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tab-items-list__create-text" }, "Ещё нет номенклатуры.", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tab-items-list__create-text" }, " Создайте новую или загрузите через Excel. ", -1))
const _hoisted_5 = { class: "tab-items-list__btns-group" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "tab-items-list__bar" }
const _hoisted_10 = { class: "tab-items-list__bar-controls" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "tab-items-list__bar-wrapp" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "tab-items-list__table-wrapp" }
const _hoisted_16 = { class: "t-table" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"t-table-row t-table-head\" data-v-4a3a19f4><div class=\"t-table-cell\" data-v-4a3a19f4>Артикул</div><div class=\"t-table-cell\" data-v-4a3a19f4>Штрихкод</div><div class=\"t-table-cell\" data-v-4a3a19f4>ШxВxГ, см</div><div class=\"t-table-cell\" data-v-4a3a19f4>Вес, кг</div><div class=\"t-table-cell\" data-v-4a3a19f4>Кол-во слоёв</div><div class=\"t-table-cell\" data-v-4a3a19f4>Кол-во в слое</div><div class=\"t-table-cell\" data-v-4a3a19f4>Хрупкость*</div><div class=\"t-table-cell\" data-v-4a3a19f4>Действия</div></div>", 1)
const _hoisted_18 = { class: "t-table-cell" }
const _hoisted_19 = { class: "t-table-cell" }
const _hoisted_20 = { class: "t-table-cell" }
const _hoisted_21 = { class: "t-table-cell" }
const _hoisted_22 = { class: "t-table-cell" }
const _hoisted_23 = { class: "t-table-cell" }
const _hoisted_24 = { class: "t-table-cell" }
const _hoisted_25 = { class: "t-table-cell" }
const _hoisted_26 = { class: "icon" }
const _hoisted_27 = { class: "icon" }
const _hoisted_28 = { class: "icon" }
const _hoisted_29 = { style: {"padding-bottom":"16px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_iconExcel = _resolveComponent("iconExcel")!
  const _component_PreloaderComponent = _resolveComponent("PreloaderComponent")!
  const _component_iconSearch = _resolveComponent("iconSearch")!
  const _component_QInput = _resolveComponent("QInput")!
  const _component_iconPlus = _resolveComponent("iconPlus")!
  const _component_iconCopy = _resolveComponent("iconCopy")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_iconEditPen = _resolveComponent("iconEditPen")!
  const _component_iconDelete = _resolveComponent("iconDelete")!
  const _component_q_pagination = _resolveComponent("q-pagination")!
  const _component_CreateNomenclatureModal = _resolveComponent("CreateNomenclatureModal")!
  const _component_EditNomenclatureModal = _resolveComponent("EditNomenclatureModal")!
  const _component_DeleteModal = _resolveComponent("DeleteModal")!
  const _component_SubmitAccountModal = _resolveComponent("SubmitAccountModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isAuth?.is_active)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.storeNomenclatures.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showNomenclatureModal && _ctx.showNomenclatureModal(...args))),
                      disabled: _ctx.state.preloader,
                      class: "btn btn-primary"
                    }, " Создать новую ", 8, _hoisted_6)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("input", {
                      type: "file",
                      ref: "fileRef",
                      hidden: "",
                      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args)))
                    }, null, 544),
                    _createElementVNode("button", {
                      class: "btn btn-primary tab-items-list__btn",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fileRef.click())),
                      disabled: _ctx.state.preloader
                    }, [
                      _createTextVNode(" Загрузить из Excel "),
                      _createElementVNode("div", null, [
                        _createVNode(_component_iconExcel)
                      ])
                    ], 8, _hoisted_7)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      class: "btn btn-primary tab-items-list__btn",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.downloadFile && _ctx.downloadFile(...args))),
                      disabled: _ctx.state.preloader
                    }, [
                      _createTextVNode(" Скачать шаблон "),
                      _createElementVNode("div", null, [
                        _createVNode(_component_iconExcel)
                      ])
                    ], 8, _hoisted_8)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.state.preloader)
            ? (_openBlock(), _createBlock(_component_PreloaderComponent, {
                key: 1,
                class: "tab-items-list__preloader"
              }))
            : _createCommentVNode("", true),
          (_ctx.storeNomenclatures.length > 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_QInput, {
                      outlined: "",
                      modelValue: _ctx.pagination.query,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pagination.query) = $event)),
                      onKeyup: _withKeys(_ctx.getNomenclature, ["enter"]),
                      dense: _ctx.dense,
                      placeholder: "Поиск номенклатуры",
                      class: "tab-rules__bar-search"
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_iconSearch, {
                          iconColor: "#21212180",
                          onClick: _ctx.getNomenclature
                        }, null, 8, ["onClick"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onKeyup", "dense"]),
                    _createElementVNode("button", {
                      class: "btn-link flex",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showNomenclatureModal && _ctx.showNomenclatureModal(...args))),
                      disabled: _ctx.state.preloader
                    }, [
                      _createTextVNode(" Добавить "),
                      _createElementVNode("div", null, [
                        _createVNode(_component_iconPlus)
                      ])
                    ], 8, _hoisted_11)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", null, [
                      _createElementVNode("input", {
                        type: "file",
                        ref: "fileRef",
                        hidden: "",
                        onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args)))
                      }, null, 544),
                      _createElementVNode("button", {
                        class: "btn btn-primary tab-items-list__btn",
                        disabled: _ctx.state.preloader,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.fileRef.click()))
                      }, [
                        _createTextVNode(" Загрузить из Excel "),
                        _createElementVNode("div", null, [
                          _createVNode(_component_iconExcel)
                        ])
                      ], 8, _hoisted_13)
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        class: "btn btn-primary tab-items-list__btn",
                        disabled: _ctx.state.preloader,
                        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.downloadFile && _ctx.downloadFile(...args)))
                      }, [
                        _createTextVNode(" Скачать шаблон "),
                        _createElementVNode("div", null, [
                          _createVNode(_component_iconExcel)
                        ])
                      ], 8, _hoisted_14)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nomenclatures, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "t-table-row",
                        key: item.id
                      }, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(item.article), 1),
                        _createElementVNode("div", _hoisted_19, _toDisplayString(item.barcode), 1),
                        _createElementVNode("div", _hoisted_20, _toDisplayString(item.width) + "х" + _toDisplayString(item.height) + "х" + _toDisplayString(item.depth), 1),
                        _createElementVNode("div", _hoisted_21, _toDisplayString(item.weight), 1),
                        _createElementVNode("div", _hoisted_22, _toDisplayString(item.max_layer_height), 1),
                        _createElementVNode("div", _hoisted_23, _toDisplayString(item.max_in_layer), 1),
                        _createElementVNode("div", _hoisted_24, _toDisplayString(item.fragility), 1),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_iconCopy, {
                              onClick: ($event: any) => (_ctx.copyNomenclature(item))
                            }, null, 8, ["onClick"]),
                            _createVNode(_component_q_tooltip, { class: "bg-tooltip" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Копировать")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_iconEditPen, {
                              onClick: ($event: any) => (_ctx.showEditNomenclatureModal(item))
                            }, null, 8, ["onClick"]),
                            _createVNode(_component_q_tooltip, { class: "bg-tooltip" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Редактировать")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createVNode(_component_iconDelete, {
                              onClick: ($event: any) => (_ctx.showDeleteNomenclatureModal(item))
                            }, null, 8, ["onClick"]),
                            _createVNode(_component_q_tooltip, { class: "bg-tooltip" }, {
                              default: _withCtx(() => [
                                _createTextVNode("Удалить")
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  (_ctx.pagination.total > 0)
                    ? (_openBlock(), _createBlock(_component_q_pagination, {
                        key: 0,
                        modelValue: _ctx.pagination.page,
                        "onUpdate:modelValue": [
                          _cache[9] || (_cache[9] = ($event: any) => ((_ctx.pagination.page) = $event)),
                          _cache[10] || (_cache[10] = (value) => _ctx.setPage(value))
                        ],
                        max: Math.ceil(_ctx.pagination.total / _ctx.pagination.page_size),
                        "direction-links": "",
                        "boundary-links": "",
                        "max-pages": 5
                      }, null, 8, ["modelValue", "max"]))
                    : _createCommentVNode("", true)
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_CreateNomenclatureModal, {
      ref: "createNomenclatureModalRef",
      onReload: _cache[11] || (_cache[11] = ($event: any) => (_ctx.getNomenclature()))
    }, null, 512),
    _createVNode(_component_EditNomenclatureModal, {
      currentItem: _ctx.form.data,
      ref: "editNomenclatureModalRef",
      onReload: _cache[12] || (_cache[12] = ($event: any) => (_ctx.getNomenclature())),
      onCopyNomenclature: _ctx.copyNomenclature
    }, null, 8, ["currentItem", "onCopyNomenclature"]),
    _createVNode(_component_DeleteModal, {
      dataProps: _ctx.form.data,
      ref: "deleteNomenclatureModalRef",
      onSubmit: _ctx.remove
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Удалить номенклатуру " + _toDisplayString(_ctx.form.data.article) + "? ", 1)
      ]),
      _: 1
    }, 8, ["dataProps", "onSubmit"]),
    _createVNode(_component_SubmitAccountModal, { ref: "submitAccountRef" }, null, 512)
  ], 64))
}